export default "__VITE_ASSET__BiLWWRDT__"